/**
 * Sign up process.
 */

'use strict';

// Constructor
var FrontContact = function () {
    if (!$('body').hasClass('contact')) {
        return;
    }

    $(document).ready((function () {
        this.initMaterializeComponents();
        this.handleSubmit();
    }).bind(this));
};

FrontContact.prototype = {
    initMaterializeComponents: function() {
        $('.col-form select').formSelect();
    },

    handleSubmit: function() {
        $('form.wpcf7-form').on('submit', function () {
            $('input[type=file]').each(function () {
                if ($(this).val() === '') {
                    $(this).remove();
                }
            });
        });
    },
};

module.exports = new FrontContact();
